import React from 'react'

import { Button, Table, Modal, Form, Col, Row } from '_zari/core'

import { DhContabilidadConstant } from 'constants/index'

import * as ActivosFijosService from 'services/activosFijos.service'

const HistorialComprasModal = ({ handleClose, show, idActivo }) => {
  const [info, setInfo] = React.useState(null)

  React.useEffect(() => {
    ActivosFijosService.getLibroActivosxId(idActivo).then(({ data }) => {
      if (data.operaciones) {
        let sumaDebe = 0
        let sumaHaber = 0

        data.operaciones = data.operaciones.map(x => {
          const montoDebe = x.tipo === DhContabilidadConstant.DEBE ? parseFloat(x.monto) : 0
          const montoHaber = x.tipo === DhContabilidadConstant.HABER ? parseFloat(x.monto) : 0

          sumaDebe += montoDebe
          sumaHaber += montoHaber

          return {
            anoMes: x.anoMes,
            fecha: x.fechaEmision,
            glosa: x.glosa,
            cuenta: x.cuentaContable,
            debe: montoDebe,
            haber: montoHaber,
            operacion: `${x.origen} - ${x.anoMes} - ${x.numeroOperacion}`
          }
        })

        if (data.operaciones.length > 0) {
          data.operaciones.push({
            fecha: 'TOTAL',
            glosa: '',
            cuenta: '',
            debe: sumaDebe,
            haber: sumaHaber,
            operacion: ''
          })

          data.operaciones.push({
            fecha: '',
            glosa: '',
            cuenta: '',
            debe: 'SALDO',
            haber: sumaDebe - sumaHaber,
            operacion: ''
          })
        }
      }

      setInfo(data)
    })
  }, [idActivo])

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>LIBRO ACTIVOS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {info && (
          <>
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label text='CODIGO' md={12} />
                  <Col md={12}>
                    <Form.InputText id='readonly-codigo' name='readonly-codigo' disabled defaultValue={info.codigo} />
                  </Col>
                </Form.Group>
              </Col>
              <Col md={8}>
                <Form.Group>
                  <Form.Label text='DESCRIPCION' md={12} />
                  <Col md={12}>
                    <Form.InputText id='readonly-descripcion' name='readonly-descripcion' disabled defaultValue={info.descripcion} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Table
              useNest={true}
              maxRowsShown={4}
              headRows={[
                { label: 'PERIODO' },
                { label: 'GLOSA' },
                { label: 'CUENTA' },
                { label: 'DEBE' },
                { label: 'HABER' },
                { label: 'OPERACION' }
              ]}
              filas={info.operaciones}
              rowTemplate={(row, k) => (
                <Table.Row key={k}>
                  <Table.Cell>{row.anoMes || '-'}</Table.Cell>
                  <Table.Cell>{row.glosa || '-'}</Table.Cell>
                  <Table.Cell>{row.cuenta || '-'}</Table.Cell>
                  <Table.Cell>{row.debe || '-'}</Table.Cell>
                  <Table.Cell>{row.haber || '-'}</Table.Cell>
                  <Table.Cell>{row.operacion || '-'}</Table.Cell>
                </Table.Row>
              )}
            />
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(HistorialComprasModal)
